import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { PublisherPixelsQuery, PublisherPixelsQueryVariables } from './__generated__/PublisherPixelsQuery';

export const PUBLISHER_PIXELS_QUERY = gql`
  query PublisherPixelsQuery($id: ID!) {
    publisherPixels(id: $id) {
      facebookPixels
      customConversions
    }
  }
`;

export const usePublisherPixelsLazyQuery = () => {
  return useLazyQuery<PublisherPixelsQuery, PublisherPixelsQueryVariables>(PUBLISHER_PIXELS_QUERY, {
    client: kmsClient
  });
};
